module Meevo.Plugins.DashboardGoals {

    import GoalCategoryEnum = Meevo.Components.Goals.GoalCategoryEnum;
    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import IGoalColumn = Meevo.Components.Goals.IGoalColumn;
    import ISelectItem = Meevo.Model.ISelectItem;

    interface DateRangeListItem {
        value: GoalDateRangeEnum;
        label: string;
    }

    interface DateRangeList extends Array<DateRangeListItem> { }

    const barChartMapFn = (list: IGoalColumn[], dateRange: GoalDateRangeEnum, $translate: ng.translate.ITranslateService, keyEnum = GoalInputTypeEnum.Currency) => {
        let key = INPUT_TYPE_KEY[keyEnum];
        return (_.groupBy(list, 'dateRangeEnum')[dateRange] || [])
            .reduce((all, item: IGoalColumn) => {
                let actualValue = item[`actual${key.slice(0, 1).toUpperCase() + key.slice(1)}`] || 0;
                let value = item[key] || 0;

                if (keyEnum === GoalInputTypeEnum.Percentage) {
                    actualValue = actualValue * 100;
                    value = value * 100;
                }

                all.push({
                    label: `${$translate.instant('LABEL_ACTUAL')} ${GOAL_CATEGORY_LABELS[item.goalCategory]}`,
                    value: actualValue,
                    color: actualValue >= value ? 'green' : 'red'
                }, {
                        label: `${$translate.instant('LABEL_GOAL')} ${GOAL_CATEGORY_LABELS[item.goalCategory]}`,
                        value: value,
                        color: '#512DA8'
                    });

                return all;
            }, []);
    };

    const INPUT_TYPE_KEY = {
        [GoalInputTypeEnum.Currency]: 'amount',
        [GoalInputTypeEnum.Percentage]: 'percent',
        [GoalInputTypeEnum.Numeric]: 'unit',
    }

    const GOAL_CATEGORY_LABELS = {
        [GoalCategoryEnum.AverageRetailTicket]: 'LABEL_RETAIL',
        [GoalCategoryEnum.AverageServiceTicket]: 'LABEL_SERVICE',
        [GoalCategoryEnum.AverageTicket]: 'LABEL_TICKET',
        [GoalCategoryEnum.Retail]: 'LABEL_RETAIL',
        [GoalCategoryEnum.Service]: 'LABEL_SERVICE',
        [GoalCategoryEnum.FrequencyOfVisit]: 'LABEL_FREQUENCY_OF_VISIT',
        [GoalCategoryEnum.NewClientsPerMonth]: 'LABEL_NEW_CLIENTS_PER_MONTH',
        [GoalCategoryEnum.RequestRate]: 'LABEL_REQUEST',
        [GoalCategoryEnum.NewClientRetention]: 'LABEL_NEW_CLIENTS',
        [GoalCategoryEnum.Rating]: 'LABEL_5_STAR_RATING',
        [GoalCategoryEnum.RepeatClientRetention]: 'LABEL_REPEAT_CLIENTS',
        [GoalCategoryEnum.GiftCard]: 'LABEL_GIFT_CARD_SALES',
    };

    class MeevoDashboardGoalsChartsViewComponent implements angular.IComponentController {

        static $inject = [
            '$scope',
            '$translate',
            '$locale'
        ];

        public goalsModel: IDashboardGoalModel;
        public globalSelectedDateRange: GoalDateRangeEnum;
        public measurement: GoalInputTypeEnum;
        public selectedYear: number;
        public onGoalDateRangeChangeEvent: (...args: any[]) => void;

        public averageTicketGoalsData: any[] = [];
        public salesGoalsData: any[] = [];
        public rebookPercentGoalsData: any[] = [];
        public frequencyOfVisitGoalsData: any[] = [];
        public newClientGoalsData: any[];
        public fiveStarRatingGoalsData: any[];
        public requestRateGoalsData: any[];
        public retentionGoalsData: any[];
        public productivityGoalsData: any[];
        public membershipGoalsData: any[];


        public averageTicketDateRangeList: DateRangeList = [];
        public salesDateRangeList: DateRangeList = [];
        public rebookDateRangeList: DateRangeList = [];
        public frequencyOfVisitDateRangeList: DateRangeList = [];
        public newClientDateRangeList: DateRangeList = [];
        public fiveStarRatingDateRangeList: DateRangeList = [];
        public requestRateDateRangeList: DateRangeList = [];
        public retentionDateRangeList: DateRangeList = [];
        public productivityDateRangeList: DateRangeList = [];
        public membershipDateRangeList: DateRangeList = [];

        public averageTicketDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;
        public salesDateRange: GoalDateRangeEnum = GoalDateRangeEnum.Today;
        public rebookDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public frequencyOfVisitDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public newClientDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public fiveStarRatingDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public requestRateDateRange: GoalDateRangeEnum = GoalDateRangeEnum.SpecificYear;
        public retentionDateRange: GoalDateRangeEnum = GoalDateRangeEnum.SpecificYear;
        public productivityDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public membershipDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;

        public measurementSelect: ISelectItem<GoalInputTypeEnum>[];
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;
        public goalCategoryEnum = GoalCategoryEnum;

        constructor(
            private $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            private $locale: angular.ILocaleService
        ) {

            Object.keys(GOAL_CATEGORY_LABELS).forEach(key => {
                GOAL_CATEGORY_LABELS[key] = $translate.instant(GOAL_CATEGORY_LABELS[key]);
            });

            this.measurementSelect = [
                { value: GoalInputTypeEnum.Currency, label: this.$translate.instant('LABEL_CURRENCY_AMOUNT', { currencySymbol: this.currencySymbol }) },
                { value: GoalInputTypeEnum.Numeric, label: 'LABEL_UNITS' },
            ];
        }

        $onInit() {
            // load default charts view
            this.$scope.$watch(() => this.goalsModel, (value) => {
                if (!value) return;
                this.prepareGraphs();
            });
        }

        onGoalDateRangeChange(data) {
            if (_.isFunction(this.onGoalDateRangeChangeEvent)) this.onGoalDateRangeChangeEvent({ data: data });
        }

        public prepareGraphs() {
            if (!_.isUndefined(this.goalsModel)) {
                if (!_.isUndefined(this.goalsModel.sales)) {
                    this.salesGoalsData = barChartMapFn(this.goalsModel.sales, this.salesDateRange, this.$translate, this.measurement);
                }
                if (!_.isUndefined(this.goalsModel.rebook)) {
                  
                   let requiredRebook = this.goalsModel.rebook && this.goalsModel.rebook.filter(row => row.dateRangeEnum === this.rebookDateRange)[0];

                    if (requiredRebook) {
                        this.rebookPercentGoalsData = [
                            { key: this.$translate.instant('LABEL_REBOOKING_PERCENT'), y: requiredRebook.rebooked, actualPercent: requiredRebook.rebooked / requiredRebook.total },
                            { key: this.$translate.instant('LABEL_NUMBER_OF_CLIENTS_WERE_NOT_REBOOKED'), y: (requiredRebook.total - requiredRebook.rebooked) }
                        ];
                    } else {
                        this.rebookPercentGoalsData = [];
                    }
                }
                if (!_.isUndefined(this.goalsModel.frequencyOfVisit)) {
                    this.salesGoalsData = barChartMapFn(this.goalsModel.sales, this.salesDateRange, this.$translate, this.measurement);
                }
                this.frequencyOfVisitGoalsData = barChartMapFn(this.goalsModel.frequencyOfVisit, this.frequencyOfVisitDateRange, this.$translate);
            }
        }

        public changeMeasurement(): void {
            if (!this.goalsModel) {
                return;
            }

            this.salesGoalsData = barChartMapFn(
                this.goalsModel.sales,
                this.salesDateRange,
                this.$translate,
                this.measurement
            );
        }
    }

    angular.module('meevo.plugins.dashboardGoals')
        .component('meevoDashboardGoalsChartsViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/dashboardGoals/components/chartsView/chartsView.component.html',
            controller: MeevoDashboardGoalsChartsViewComponent,
            controllerAs: 'vm1',
            bindings: {
                goalsModel: '=',
                globalSelectedDateRange: '=',
                selectedYear: '=',
                onGoalDateRangeChangeEvent: '&'
            }
        });
}